import React from 'react';
import { LockClosed20Filled } from '@fluentui/react-icons';
import { CHAT_ICON_COLOR } from './ChatIcons.constants';

export const ChatIconsLocked = () => {
  return <LockClosed20Filled color={CHAT_ICON_COLOR} aria-hidden="true" />;
};
